import React, { useEffect, useState } from 'react'
import { getCourseLessonCurrentLevelReports, saveOverviewTexts, getOverviewTexts } from '../../../lib/studentcourselessonreport'
import { ReportCard, ToastNotification, OverviewTextarea, UpdateButton } from './CourseReportComponents'
import { getHeaderClass, sortLevels } from './CourseReportUtils'
import style from './CourseReportStyles.module.css'

export const CourseLessonReport = ({ studentId, isStudent = false }) => {
	const [current, setCurrent] = useState({})
	const [departments, setDepartments] = useState([])
	const [levels, setLevels] = useState([])
	const [overview, setOverview] = useState({})
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	useEffect(() => {
		loadData()
	}, [studentId])

	const loadData = async () => {
		const currentRes = await getCourseLessonCurrentLevelReports(studentId)
		const overviewRes = await getOverviewTexts(studentId)

		const dataMap = {}
		const deptSet = new Set()
		const levelSet = new Set()

		currentRes.forEach((item) => {
			const { department, ...rest } = item
			deptSet.add(department)
			dataMap[department] = {}

			Object.entries(rest).forEach(([key, value]) => {
				if (key !== 'studentId') {
					dataMap[department][key] = value ?? 0
					if (key !== 'Total') levelSet.add(key)
				}
			})
		})

		const overviewMap = {}
		overviewRes.forEach((item) => {
			overviewMap[item.type] = item.desc
		})

		setCurrent(dataMap)
		setDepartments([...deptSet])
		setLevels(sortLevels([...levelSet]))
		setOverview(overviewMap)
	}

	const handleOverviewChange = (value) => {
		setOverview((prev) => ({ ...prev, clevelTest: value }))
	}

	const handleUpdate = async () => {
		await saveOverviewTexts(studentId, { clevelTest: overview.clevelTest || '' })
		showToastMessage('Update successful!')
		loadData()
	}

	return (
		<ReportCard title="Course Load">
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />

			<table className="table table-bordered text-center">
				<thead>
					<tr>
						<th style={{ width: '150px' }}>Department</th>
						<th>Total</th>
						{levels.map((lvl) => (
							<th key={lvl} className={style[getHeaderClass(lvl)]}>
								{lvl}
							</th>
						))}
						<th style={{ width: '400px' }}>Overview</th>
					</tr>
				</thead>
				<tbody>
					{departments.map((dept, index) => (
						<tr key={dept}>
							<td>{dept}</td>
							<td className={style.totalCell}>{current[dept]?.Total || 0}</td>
							{levels.map((lvl) => (
								<td key={lvl} className={current[dept]?.[lvl] > 0 ? style[getHeaderClass(lvl)] : ''}>
									{current[dept]?.[lvl] ?? 0}
								</td>
							))}
							{index === 0 && (
								<td rowSpan={departments.length} className={style.overviewCell}>
									<div className="h-100 w-100 d-flex flex-column justify-content-between">
										<OverviewTextarea
											value={overview['clevelTest'] || ''}
											onChange={handleOverviewChange}
											rows={departments.length * 2}
											isStudent={isStudent}
										/>
									</div>
								</td>
							)}
						</tr>
					))}
					{/* Total row */}
					<tr style={{ fontWeight: 'bold', background: '#f0f0f0' }}>
						<td>Total</td>
						<td className={style.totalCell}>{departments.reduce((sum, dept) => sum + (current[dept]?.Total || 0), 0)}</td>
						{levels.map((lvl) => (
							<td key={lvl} className={style[getHeaderClass(lvl)]}>
								{departments.reduce((sum, dept) => sum + (current[dept]?.[lvl] || 0), 0)}
							</td>
						))}
						<td></td>
					</tr>
				</tbody>
			</table>

			<UpdateButton onClick={handleUpdate} isStudent={isStudent} />
		</ReportCard>
	)
}
